import { isNil } from "lodash";
import PropTypes from "prop-types";
import React from "react";

import { getShortEraName, getShortMonthName } from "../../modules/definition/calendar/dateFunctions/stringFromDate";
import { Precision, PropTypeShapes } from "../../types";
import FormSegmentControl from "../form/FormSegmentControl";
import CalendarPickerRow from "./CalendarPickerRow";

const dateToSegmentOptions = (date, calendar) => {
  let options = [];

  if (date.precision > Precision.Month) {
    options.push({
      label: getShortMonthName(calendar, date.month),
      value: Precision.Month
    });
  }
  if (!isNil(date.year)) {
    options.push({ label: date.year.toString(), value: Precision.Year });
  }
  options.push({
    label: getShortEraName(calendar, date.era),
    value: Precision.Century
  });
  return options;
};

const CalendarPickerSelectorController = props => {
  const options = dateToSegmentOptions(props.date, props.calendar);
  let precision = props.selectedPrecision;

  if (options.findIndex(opt => opt.value === precision) === -1) {
    precision = null;
  }

  return (
    <CalendarPickerRow>
      <div className={`calendarPickerSelectorController`}>
        <div className="backButton" onClick={props.onPrevGrid}>
          <svg className={"icon"}>
            <use xlinkHref="#leftArrow" />
          </svg>
        </div>
        <FormSegmentControl
          options={options}
          className="calendarPickerSelectorControllerSegment"
          value={precision}
          onClick={props.onSelectedPrecisionChange}
        />
        <div className="forwardButton" onClick={props.onNextGrid}>
          <svg className={"icon"}>
            <use xlinkHref="#rightArrow" />
          </svg>
        </div>
      </div>
    </CalendarPickerRow>
  );
};

CalendarPickerSelectorController.propTypes = {
  calendar: PropTypeShapes.calendar.isRequired,
  date: PropTypeShapes.dateRelated,
  selectedPrecision: PropTypes.number.isRequired,
  onSelectedPrecisionChange: PropTypes.func.isRequired,
  onNextGrid: PropTypes.func.isRequired,
  onPrevGrid: PropTypes.func.isRequired
};

export default CalendarPickerSelectorController;
